import { render, staticRenderFns } from "./PaginationButtons.vue?vue&type=template&id=5c51c9c7&scoped=true&"
import script from "./PaginationButtons.vue?vue&type=script&lang=ts&"
export * from "./PaginationButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c51c9c7",
  null
  
)

export default component.exports